import { CompaniesNav, TeamNav } from '@clearkit/icons';
import {
  // CKActionMenu,
  CKContainerProps,
  CKLayoutGridAuto,
  CKLayoutHorizontal,
  // CKPopover,
} from 'clearkit';

import { ItemCount } from '~/components/ListItem/ItemCount';
import { PageLayout } from '~/components/PageLayout';

import {
  MAX_COUNT_HIDE,
  MAX_COUNT_HIDE_LABEL,
} from '../useProspector/constants';
import { hideListSmall } from './constants';
import { PaginationButtons } from './PaginationButtons';

type ListHeaderProps = CKContainerProps & {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onNextPage?: () => void;
  onPreviousPage?: () => void;
  pageEnd?: number;
  pageStart?: number;
  previousTotalCompanies?: number;
  previousTotalProspects?: number;
  totalCompanies?: number;
  totalProspects?: number;
};

// const ActionMenu = (
//   <CKActionMenu>
//     <CKActionMenu.Item>Display all</CKActionMenu.Item>
//     <CKActionMenu.Item>Display only selected</CKActionMenu.Item>
//   </CKActionMenu>
// );

export const ListHeader = ({
  hasNextPage,
  hasPreviousPage,
  pageStart,
  pageEnd,
  previousTotalCompanies = 0,
  previousTotalProspects = 0,
  onNextPage,
  onPreviousPage,
  totalProspects = 0,
  totalCompanies = 0,
}: ListHeaderProps) => {
  return (
    <PageLayout.HeaderWrapper className="py-3 pb-3 xl:py-3">
      <CKLayoutHorizontal className="@item/list:flex-nowrap">
        <CKLayoutGridAuto
          autoRepeat="auto-fit"
          className="min-w-0 basis-auto shrink grow max-w-[26rem]"
          minWidth="8rem"
        >
          <ItemCount
            end={totalCompanies}
            hideCountAbove={MAX_COUNT_HIDE}
            hideCountLabel={MAX_COUNT_HIDE_LABEL}
            label={totalCompanies === 1 ? 'company' : 'companies'}
            start={previousTotalCompanies}
          >
            <CompaniesNav height={18} width={18} />
          </ItemCount>
          <ItemCount
            end={totalProspects}
            hideCountAbove={MAX_COUNT_HIDE}
            hideCountLabel={MAX_COUNT_HIDE_LABEL}
            label={totalProspects === 1 ? 'prospect' : 'prospects'}
            start={previousTotalProspects}
          >
            <TeamNav height={18} width={18} />
          </ItemCount>
        </CKLayoutGridAuto>
        <CKLayoutHorizontal className="basis-auto" justifyContent="end">
          {/* <CKPopover popover={ActionMenu} wrapperClassName="relative">
            <CKPopover.Trigger
              className="!text-sm"
              variant="tertiary"
              variantColor="blue"
            >
              <span className={hideListSmall}>Displaying</span>
              {pageStart} - {pageEnd}
            </CKPopover.Trigger>
          </CKPopover> */}
          <div className="text-sm text-gray-600">
            <span className={hideListSmall}>Displaying</span>{' '}
            <span>
              {pageStart} – {pageEnd}
            </span>
          </div>
          <PaginationButtons
            hasNextPage={hasNextPage}
            hasPreviousPage={hasPreviousPage}
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
          />
        </CKLayoutHorizontal>
      </CKLayoutHorizontal>
    </PageLayout.HeaderWrapper>
  );
};
